import { render, staticRenderFns } from "./multifileupload.vue?vue&type=template&id=3a64e73a"
import script from "./multifileupload.vue?vue&type=script&lang=ts"
export * from "./multifileupload.vue?vue&type=script&lang=ts"
import style0 from "./multifileupload.vue?vue&type=style&index=0&id=3a64e73a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports